<!-- =========================================================================================
  File Name: nouveauarticles.vue
  Description: nouveauarticles Page
  ----------------------------------------------------------------------------------------

========================================================================================== -->

<template>
<div id="nouveauarticles-page">

    <!--    <vs-popup @closePopup="HideChartfunction()" style="color:rgb(255,255,255) ;  width: 100%;" background-color="rgba(188 ,188,188,.6)" :background-color-popup="colorx" title="Nouveau Article" :active.sync="popupActivo5">
        <div class="vx-col mb-4 vx-col md:w-full">
            <div class="flex justify-center">
                 <div class=" bg-grid-color-secondary h-20 p-2  ">

                </div>
                <div class="  bg-grid-color-secondary h-20 p-2 justify-center">
                    <vs-button class="block text-gray-700 text-sm font-bold" @click.stop="setType('PARA')">PARA</vs-button>
                </div>
                <div class="  bg-grid-color-secondary h-20 p-2 justify-center md:ml-5">
                    <vs-button class="block text-gray-700 text-sm font-bold" @click.stop="setType('PHARMA')">PHARMA</vs-button>
                </div>
            </div>

        </div>
    </vs-popup> -->
    <div class="vx-col">
        <div class="vx-row  bg-gray-200 p-4">
            <div class=" w-2/5">
            </div>
            <vs-switch color="primary" v-model="type" class="md:w-1/6 ">
                <span slot="off">PHARMA</span>
                <span slot="on">PARA</span>
            </vs-switch>
        </div>
        <nouveau-p-a-r-a v-if="type" />
        <nouveau-p-h-a-r-m-a v-else-if="type==false" />
    </div>
</div>
</template>

<script>
import NouveauPARA from "./NouveauPARA.vue"
import NouveauPHARMA from "./NouveauPHARMA.vue"
//import service from "./dashboardService.js";
import vSelect from "vue-select";
export default {

    data() {
        return {
            colorx: this.$store.state.themePrimaryColor,
            popupActivo5: true,
            type: true
        };
    },
    watch: {
        type: function (params) {
            console.log(params)
        }
    },
    computed: {},
    methods: {

        setType(type) {

            this.type = type;
            this.popupActivo5 = false;
        },
        HideChartfunction() {
            this.popupActivo5 = true;
        },


    },
    mounted() {},
    components: {
        vSelect,
        NouveauPARA,
        NouveauPHARMA
    }
};
</script>

<style lang="scss">
</style>
